export const tableHeadings = [ 'Title', 'Description'];